import React from "react";
import classNames from "classnames";

import { useLoader } from "./useLoader";

/**
 * Primary UI component for user interaction
 */
const NCLoader = (props) => {
  const {
    label,
    labelColor,
    classes,
    color,
    loaderContentBgColor,
    isStoryBookRender,
    variantType,
    size,
    logoColor,
    borderWidth,
    labelMargin,
    fontWeight,
    fontSize,
  } = props;

  const loaderComponent = useLoader(props);

  return (
    <div
      className={classNames(
        `${[
          "left-0 right-0 bg-[#00000063] w-full h-full flex justify-center items-center overflow-hidden top-0 ",
          isStoryBookRender ? "" : "fixed",
        ].join(" ")} ${classes}`,
      )}
      style={{ zIndex: "999999999" }}
      {...props}
    >
      <div style={loaderContentBgColor && { background: loaderContentBgColor }} className='p-32 pt-12 rounded'>
        {loaderComponent?.LoaderComponent}
        {label && (
          <div
            className={`mt-${labelMargin} text-center ${fontWeight ? "font-bold" : ""}`}
            style={{ color: labelColor, fontSize: fontSize ? fontSize : "" }}
          >
            {label}
          </div>
        )}
      </div>
    </div>
  );
};

export default NCLoader;
